<template>
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M20 32V8M8 20H32" stroke="black" stroke-width="1.5" stroke-linecap="square" stroke-linejoin="round" />
  </svg>
</template>
